import DispatchRegister from "../../../../../components/units/Management/Dispatch/Register";
import { DISPATCH_TARGET } from "../../../../../shared/constants/dispatchTarget";

export default function DispatchManufacturerRegisterPage() {
  return <DispatchRegister target={DISPATCH_TARGET.manufacturer} />;
}
